import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type SidebarState = {
  isCollapsed: boolean
  isAutoCollapsed: boolean
  toggle: () => void
  setCollapsed: (collapsed: boolean) => void
  setAutoCollapsed: (auto: boolean) => void
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    set => ({
      isCollapsed: false,
      isAutoCollapsed:
        typeof window !== 'undefined'
          ? !window.matchMedia('(min-width: 1280px)').matches
          : false,
      toggle: () =>
        set(state => {
          const effectivelyCollapsed =
            state.isCollapsed || state.isAutoCollapsed
          return {
            isCollapsed: !effectivelyCollapsed,
            isAutoCollapsed: false,
          }
        }),
      setCollapsed: (collapsed: boolean) => set({ isCollapsed: collapsed }),
      setAutoCollapsed: (auto: boolean) => set({ isAutoCollapsed: auto }),
    }),
    {
      name: 'sidebar',
      partialize: state => ({ isCollapsed: state.isCollapsed }),
    }
  )
)
